export class Customerservice {
  groupName: string;
  searchText: string;
  ParkId: string;
  groupId: string;
  userId:string;
  checkedForGroup: any;
  checkedForItPark: any;
  userid: any;
  userSelectedGroupIds: any;
  userSelectedParkIds: any;
}
